export default {
  ACTIVE: {
    Title: 'Active',
    Color: '#FFE0CC',
  },
  PROFILE_PENDING: {
    Title: 'Profile pending',
    Color: '#FFD54F',
  },
  PROFILE_REVIEW: {
    Title: 'Profile review',
    Color: '#fdc200ff',
  },
  INACTIVE: {
    Title: 'Inactive',
    Color: '#767676',
  },
};
